import styled from "styled-components";

export const Container = styled.div(({ theme }) => ({
    width: "100vw",
    maxWidth: "100vw",
    display: "flex",
    flexDirection: "column",
    position: "relative",
    height: "100%",
    background:
        theme.colorMode === "light"
            ? theme.colors[theme.colorMode].background_Secondary
            : theme.colors.dark.canvas_Primary,
}));

export const FlexContainer = styled.div({
    flexGrow: 1,
    overflowY: "scroll",
});

export const BottomWidget = styled.div({
    height: 150,
    width: "100%",
});

export const StyledTitleBar = styled.div(({ theme }) => ({
    height: 50,
    minHeight: 50,
    position: "sticky",
    backgroundColor: theme.colors[theme.colorMode].canvas_Primary,
    top: 0,
    zIndex: 1,
}));

export const OverLayLoader = styled("div")(({ theme }) => ({
    width: "100vw",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: theme.colors[theme.colorMode].canvas_Primary,
}));

export const OverLayError = styled("div")(({ theme }) => ({
    position: "absolute",
    inset: 0,
    zIndex: 1000,
    background: theme.colors[theme.colorMode].canvas_Primary,
}));
